import { ColorValue, colors } from '@optical/utils';

export const ColorSuccess = colors.green['500'];
export const ColorSuccessHover = colors.green['400'];

export const ColorFailure = colors.red['500'];
export const ColorFailureHover = colors.red['400'];

export const CompareColors = {
  50: getCompareColors(50),
  100: getCompareColors(100),
  200: getCompareColors(200),
  300: getCompareColors(300),
  400: getCompareColors(400),
  500: getCompareColors(500),
  600: getCompareColors(600),
  700: getCompareColors(700),
  800: getCompareColors(800),
  900: getCompareColors(900),
  950: getCompareColors(950),
};

export function compareColorAt(index: number, value: ColorValue = 500): string {
  return CompareColors[value][index % CompareColors[value].length];
}

/**
 * Adds an alpha channel to a hexadecimal color code.
 * @param hex - The hexadecimal color code.
 * @param alpha - The alpha value (between 0 and 1) to be added.
 * @returns The updated hexadecimal color code with the alpha channel.
 */
export function hexAlpha(hex: string, alpha: number): string {
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0');

  return hex + alphaHex;
}

function getCompareColors(value: ColorValue = 500): string[] {
  return [
    colors.purple[value],
    colors.orange[value],
    colors.yellow[value],
    colors.pink[value],
    colors.lime[value],
  ];
}
